var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "notice notice-box--type" }, [
    _c("div", { staticClass: "notice-tit" }, [
      _c("p", { staticClass: "bullet" }, [
        _vm._v(_vm._s(_vm.title || _vm.$t(_vm.titleI18n)))
      ])
    ]),
    _c("div", { staticClass: "notice-cont" }, [_vm._t("content")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }